import PropTypes from 'prop-types';
import NavBarDropdownElement from './NavBarDropdownElement';
import { generateKey } from '../../utils/CommonUtils';
import { Component } from 'react';

class NavBarDropdown extends Component {
	render() {
		const items = this.props.elements.map((entry, idx) => {
			const caption = entry ? entry.caption : '';
			return <NavBarDropdownElement {...entry} key={generateKey(caption, idx)} parentName={this.props.parentName} />;
		});
		return <ul className="navbar__dropdown-menu">{items}</ul>;
	}
}

NavBarDropdown.propTypes = {
	parentName: PropTypes.string,
	elements: PropTypes.arrayOf(
		PropTypes.shape({
			caption: PropTypes.string,
			link: PropTypes.string,
			isHighlighted: PropTypes.bool,
			isNew: PropTypes.bool,
			iconClass: PropTypes.string,
			scrollToTop: PropTypes.bool,
			gaTracking: PropTypes.string,
		}),
	),
};

NavBarDropdown.defaultProps = {
	elements: [],
};

export default NavBarDropdown;
